<template>
  <ActivityLayout>
    <div class="app-main">
      <router-view></router-view>
    </div>
  </ActivityLayout>
</template>
<script>
import ActivityLayout from "@/layout/ActivityLayout.vue";
export default {
  name: "index",
  props: {},
  components: { ActivityLayout },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.app-main {
  overflow-x: auto;
  width: 100%;
  height: 100%;
  padding: 40px 0px !important;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .app-main {
    overflow-x: auto;
    padding: 16px !important;
    width: 100%;
    height: 100%;
  }
}
</style>
